export default __webpack_public_path__ + "static/media/miner.316587c0.png";